import React from 'react'
import { Svg } from './Svg'

export function Magnify(props): React.JSX.Element {
    return (
        <Svg {...props} viewBox="0 0 256 256">
            <circle cx="116" cy="116" fill="none" r="84" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"/>
            <line fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16" x1="175.4" x2="224" y1="175.4" y2="224"/>
        </Svg>
    )
}

// Phosphor+user